import { Route, Routes } from 'react-router-dom';
import './App.css';
import { Provider } from 'react-redux';
import store from './store'
import AppRouter from './AppRouter';
import { Layout } from './components/Layout';

function App() {
  return (
    <Provider store={store}>
      <Layout>
        <Routes>
          {AppRouter.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} {...rest} element={element} />;
          })}
        </Routes>
      </Layout>
    </Provider>
  );
}

export default App;
